import * as React from 'react';
import styled from '@emotion/styled';
import { useFormik } from 'formik';
import { AbstractGroupType, Group } from '@foxbun/lib-goferal-types';
import { InputContainerWidget } from '../../../widgets/forms/InputContainerWidget';
import { TextInputType, TextInputWidget } from '../../../widgets/forms/TextInputWidget';
import { ButtonWidget } from '../../../widgets/controls/ButtonWidget';
import { useSystem } from '../../../hooks/useSystem';
import { observer } from 'mobx-react';
import { useNavigate } from 'react-router-dom';

export const CreateGroupPage: React.FC = observer(() => {
  const system = useSystem();
  const navigate = useNavigate();
  const { errors, getFieldHelpers, values, isValid, isSubmitting, submitForm } = useFormik<Group>({
    initialValues: {
      name: '',
      about: '',
      public: true,
      type: AbstractGroupType.GROUP
    },
    onSubmit: async (pack) => {
      await system.session.api_client.groups.createGroup(pack);
      navigate(-1);
    }
  });
  return (
    <S.Container>
      <InputContainerWidget label="Group Name" error={errors.name}>
        <TextInputWidget type={TextInputType.TEXT} value={values.name} onChange={getFieldHelpers('name').setValue} />
      </InputContainerWidget>
      <InputContainerWidget label="About" error={errors.about}>
        <TextInputWidget
          type={TextInputType.PARAGRAPH}
          value={values.about}
          onChange={getFieldHelpers('about').setValue}
        />
      </InputContainerWidget>
      <ButtonWidget
        disabled={!isValid}
        loading={isSubmitting}
        label="Create group"
        action={() => {
          submitForm();
        }}
      />
    </S.Container>
  );
});
namespace S {
  export const Container = styled.div`
    padding: 10px;
    display: flex;
    flex-direction: column;
    row-gap: 10px;
  `;
}
